<template>
    <section>
        <SideBar v-if="!OpenMode" />
        <TopBar v-if="!OpenMode" />
        <div :class="[!OpenMode ? 'content' : '' ]">   
        <div class="main-content-header">
            <h1>Maestro de Sucursales</h1>
        </div>
        <LoadingContent v-if="isLoading" />
        <div class="row">
            <div class="col-lg-12 col-md-6">
                <div class="card mb-30" :style="{height:[contentHeight+'px']}">
                    <div class="row " :class="[!OpenMode ? 'p-4' : '']">
                        <div class="content-header  col-12"> 
                            <div class="row">
                                <div class="col-md-10 col-12 text-start "></div>
                                <div class="col-md-2 col-12"><p class="p-1 pe-4 mb-0 text-end">Página {{ paginaActual }} de {{ totalPaginas }} </p></div>
                                <div class="col-md-2 offset-md-10 col-12 ps-2 pe-5 text-end pb-0 pt-0">
                                    <ul class="list-unstyled mb-0 d-flex justify-content-between pager-btns float-right">
                                        <li><button @click="setPaginacion('first')" type="button" class="pager pager-first btn btn-sm btn-outline-secondary"><ChevronDoubleLeftIcon /></button></li>
                                        <li><button @click="setPaginacion('prev')"  type="button" class="pager pager-prev  btn btn-sm btn-outline-secondary"><ChevronLeftIcon /></button></li>
                                        <li><button @click="setPaginacion('next')"  type="button" class="pager pager-next  btn btn-sm btn-outline-secondary"><ChevronRightIcon /></button></li>
                                        <li><button @click="setPaginacion('last')"  type="button" class="pager pager-last  btn btn-sm btn-outline-secondary"><ChevronDoubleRightIcon /></button></li> 
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-10 col-12">
                            <div class="table-responsive ps-2">
                                <b-table-simple class="browse" hover small caption-top responsive >
                                    <b-thead head-variant="light" class="table-header">
                                        <b-tr>
                                            <b-th class="text-nowrap">Suc</b-th>
                                            <b-th class="text-nowrap">Nombre</b-th>
                                            <b-th class="text-nowrap">RFC</b-th>
                                            <b-th class="text-nowrap ">Calle</b-th>
                                            <b-th class="text-nowrap ">Colonia</b-th>
                                            <b-th class="text-nowrap ">Estado</b-th>
                                            <b-th class="text-nowrap ">Pais</b-th>
                                            <b-th class="text-nowrap ">CP</b-th>
                                            <b-th class="text-nowrap ">Bodega Principal</b-th>
                                            <b-th class="text-nowrap ">Estatus</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="(suc,indx) in sucursales" :key="suc.clave" 
                                        @click="selectedRegistro=suc;selectedRegistro.indx = indx" 
                                        @dblclick="(!OpenMode ? modificar() : exportRegistry()) " :class="{ 'selected-row': (selectedRegistro.sucursal == suc.sucursal) }">
                                            <b-td class="text-nowrap text-center">{{suc.sucursal}}</b-td>
                                            <b-td class="text-nowrap">{{ suc.nombre }}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.rfc }}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.calle}}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.colonia}}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.estado}}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.pais}}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.cp}}</b-td>
                                            <b-td class="text-nowrap text-end">{{ suc.bodegaprincipal}}</b-td>
                                            <b-td class="text-nowrap ">{{ suc.estatus}}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </div>
                        </div> 
                        <div class="col-2 ps-2 pe-5 btn-manager" >
                            <ul class="d-block list-unstyled action-block">
                                <li v-if="!OpenMode"><router-link to="/sucursales/agregar" class="btn btn-xs btn-success btn-block">Agregar</router-link></li>
                                <li v-if="!OpenMode"><button @click="modificar()" :disabled="disableBtn" type="button" class="btn btn-xs btn-primary btn-block">Cambiar</button></li>
                                <li v-if="!OpenMode"><button @click="ask()" :disabled="disableBtn" class="btn btn-xs btn-danger btn-block">Borrar</button></li>
                                <li v-if="!OpenMode"><button @click="imprimir()" class="btn btn-xs btn-secondary btn-block">Imprimir</button></li>
                                <li v-if="OpenMode"><button @click="exportRegistry()" class="btn btn-xs btn-success btn-block">Elegir</button></li>
                            </ul>
                        </div>
                        
                        <div class="content-footer col-12 text-start"></div>
                    </div>
                </div>
            </div>
        </div>
        <DeleteReg  v-show="showDelete" @close="closeDelete" @aceptar="sucursales = borrar('InSucursales',sucursales)">
            <template v-slot:header>
                <h6 class="text-uppercase">{{notificationTitle}}</h6>
            </template>
            <template v-slot:body>
                {{notificationText}}
            </template>
        </DeleteReg>
    </div>
    </section>
</template>

<script>
import DeleteReg from '@/components/YesNoPopup.vue';
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronDoubleLeftIcon from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'
import handleBrowse from '@/mixins/handleBrowse'
import handlePopUp from '@/mixins/handlePopUp'

import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';
import axios from 'axios';
export default {
    name:'WIN_InSucursales',
    props:['mode','perpage'],
    mixins:[handleGlobals,handleBrowse,handlePopUp],
    components:{SideBar,TopBar,ChevronLeftIcon,ChevronDoubleRightIcon,ChevronDoubleLeftIcon,ChevronRightIcon, LoadingContent,DeleteReg},
    data(){
        return{
            sucursales: []
        }
    },
    created(){
        if(this.OpenMode == false){
            this.getFiltros()
        } 
    },
    methods:{
        async getFiltros(){
                await fetch(this.$api+'/rdx', {    
                    method: "POST",
                    headers: {
                        'Content-Type' : 'application/json',
                        'Authorization' : this.$store.state.iasctratkn
                    },
                    body: JSON.stringify({accion: "filters"})
                }).then((response)=>{
                    if(response.ok){
                        return response.json()
                    }
                }).then((data)=>{
                    let reg = data['SUC']
                    if(reg){
                        this.paginaActual       = reg['paginaActual'].dato
                        if(this.paginaActual == '') this.paginaActual = 0
                    }else{
                        this.paginaActual       = 1
                    }
                }).catch((err)=>{
                    this.falseToken(err)
                });
        },
        consultar(){
            this.isLoading = true
            axios.post(this.$api+'/rdx',{  accion: "browse", 
                                        archivo: "InSucursales", 
                                        activarPaginas: true,
                                        orden: "sucursal",
                                        filtro: {paginaActual: {dato: 'NA'}},
                                        pagina: this.paginaActual, 
                                        paginacion: this.paginacion,
                                        registrosxpagina: this.rows },{
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
            }).then((res)=>{
                if(res.msg){
                    this.msg_err = res.msg
                }else{
                    this.sucursales     = res.data['registros'];
                    this.totalRegistros = res.data['totalRegistros'];
                    this.totalPaginas   = res.data['totalPaginas'];
                    this.paginaActual   = res.data['paginaActual'];
                }
            }).finally(()=>{
                this.isLoading = false;
            }).catch((err)=>{
              console.log(err)
            }).finally(()=>{
                this.isLoading = false;
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        imprimir(){

        },
        modificar(){
            this.$router.push({ name: 'CInSucursales', params: {sucursal: this.selectedRegistro.sucursal}});
        }
    }
}
</script>

